import { queryElementBy } from '@doltech/core/lib/hooks/useElementQuerySelector';
import { ScrollType, smoothScroll } from '@doltech/utils/lib/smooth-scroll';
import { flatMap } from 'lodash';

export const onContentItemClick = (id, scrollContainerElm: string | HTMLElement | Window) => {
  const element = document.getElementById(id);
  const containerElm = queryElementBy(scrollContainerElm);
  let parrent = 0;
  if (document.getElementById('blog-preview-content')) {
    parrent = (document.getElementsByClassName('blog-editor-body')[0] as any)?.offsetTop || 0;
  }

  if (element && containerElm) {
    smoothScroll(300, containerElm, element.offsetTop + parrent - 142, ScrollType.VERTICAL, () => {
      if (window.history.replaceState) {
        window.history.replaceState(undefined, undefined, `#${id}`);
      } else {
        window.location.hash = id;
      }
    });
    if (window.history.replaceState) {
      window.history.replaceState(undefined, undefined, `#${id}`);
    } else {
      window.location.hash = id;
    }
  }
};

// export const tableOfContentFlatMap = (tableOfContent) => {
//   const listOfItems = [];
//   tableOfContent?.forEach(h2Item => {
//     listOfItems.push(h2Item);
//     if (h2Item?.sub?.length) {
//       h2Item?.sub?.forEach(h3Item => {
//         listOfItems.push(h3Item);
//         if (h3Item?.sub?.length) {
//           h3Item?.sub?.forEach(h4Item => {
//             listOfItems.push(h4Item);
//           });
//         }
//       });
//     }
//   });
//   return listOfItems.filter(Boolean);
// };

export const tableOfContentFlatMap = (tableOfContent) =>
  flatMap(tableOfContent, (item) => {
    if (item.sub) {
      const { sub, ...parentItem } = item;
      return [parentItem, ...sub];
    }
    return item;
  });
